import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Copy = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16 13.6695V17.8695C16 21.3695 14.6 22.7695 11.1 22.7695H6.9C3.4 22.7695 2 21.3695 2 17.8695V13.6695C2 10.1695 3.4 8.76953 6.9 8.76953H11.1C14.6 8.76953 16 10.1695 16 13.6695Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 7.66953V11.8695C22 15.3695 20.6 16.7695 17.1 16.7695H16V13.6695C16 10.1695 14.6 8.76953 11.1 8.76953H8V7.66953C8 4.16953 9.4 2.76953 12.9 2.76953H17.1C20.6 2.76953 22 4.16953 22 7.66953Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Copy.displayName = 'Copy';
